export enum HelpDeskStatusEnum {  
  PendingReview = 1,
  Completed = 2
}
